export default __webpack_public_path__ + "static/superbetter-design-1-c657f7ebe5c334ea92f06d86a1035d22.webp";